type RelativeTo<
  Full extends string,
  Base extends string,
> = Full extends `${Base}${infer Rest}` ? Rest : never;

export const relativeTo = <Full extends string, Base extends string>(
  fullPath: Full,
  basePath: Base,
): RelativeTo<Full, Base> => {
  return fullPath.slice(basePath.length) as RelativeTo<Full, Base>;
};
